module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAgsAAAAmCAYAAABK8tgPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACrSURBVHhe7daBAAAADASh+Uv/DI6gKLoBAARZAACSLAAASRYAgCQLAECSBQAgyQIAkGQBAEiyAAAkWQAAkiwAAEkWAIAkCwBAkgUAIMkCAJBkAQBIsgAAJFkAAJIsAABJFgCAJAsAQJIFACDJAgCQZAEASLIAACRZAACSLAAASRYAgCQLAECSBQAgyQIAkGQBAEiyAAAkWQAAkiwAAEkWAIAkCwBAkgUAIGwPmTNjlFyqeZEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/kong.jpg
// module id = 3qUL
// module chunks = 0